import { api } from './client'

/**
 * F-061 (TASK-0315) — process mining (`ProcessMiningController`, policy Manager). Durate in ORE. Nessun
 * importo in questo payload. `from`/`to` sono giorni "YYYY-MM-DD" (Europe/Rome, estremi inclusi); se
 * omessi il backend usa gli ultimi 30 giorni.
 */
export type ProcessGroupBy = 'agent' | 'team' | 'operator' | 'department'

export interface ProcessPhaseStat {
  phaseKey: string
  title: string
  n: number
  medianHours: number | null
  p75Hours: number | null
  p90Hours: number | null
  /** Quota della mediana sulla somma delle mediane (0..100); null se la fase non è misurata. */
  sharePct: number | null
}

export interface ProcessSegmentRow {
  phaseKey: string
  phaseTitle: string
  segmentKey: number
  segmentLabel: string
  n: number
  medianHours: number
  globalMedianHours: number
  ratioVsGlobal: number | null
  anomalous: boolean
}

export interface ProcessBaseline {
  from: string
  to: string
  phases: ProcessPhaseStat[]
}

export interface ProcessAnomaly {
  kind: 'baseline' | 'segment'
  phaseKey: string
  phaseTitle: string
  segmentKey: number | null
  segmentLabel: string | null
  baseline: string | null
  medianHours: number
  referenceHours: number
  deviationPct: number
  title: string
}

export interface ProcessMiningReport {
  from: string
  to: string
  groupBy: ProcessGroupBy
  deviationPct: number
  minSample: number
  thresholdsProvisional: boolean
  phases: ProcessPhaseStat[]
  bottleneck: { phaseKey: string; title: string; sharePct: number } | null
  segments: ProcessSegmentRow[]
  baselines: {
    last30: ProcessBaseline
    last90: ProcessBaseline
    samePeriodLastYear: ProcessBaseline
  }
  anomalies: ProcessAnomaly[]
  excluded: { migrati: number; negativi: number }
  gaps: string[]
}

export interface ProcessMiningFilters {
  from?: string | undefined
  to?: string | undefined
  groupBy?: ProcessGroupBy | undefined
  deviationPct?: number | undefined
  minSample?: number | undefined
}

function qs(f: ProcessMiningFilters): string {
  const p = new URLSearchParams()
  if (f.from) p.set('from', f.from)
  if (f.to) p.set('to', f.to)
  if (f.groupBy) p.set('groupBy', f.groupBy)
  if (f.deviationPct !== undefined) p.set('deviationPct', String(f.deviationPct))
  if (f.minSample !== undefined) p.set('minSample', String(f.minSample))
  const s = p.toString()
  return s ? `?${s}` : ''
}

export const processMiningApi = {
  get: (f: ProcessMiningFilters = {}) => api<ProcessMiningReport>(`/api/reports/process-mining${qs(f)}`),
}
